import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  AssignSalaryStructureToEmployeesGraphResponse,
  AssignSalaryStructureToEmployeesGraphQLRequest,
} from '../types';

const assignSalaryStructureToEmployeesMutation = gql`
  mutation PayrollAssignSalaryStructureToEmployees(
    $input: PayrollAssignSalaryStructureToEmployeeInput!
  ) {
    payrollAssignSalaryStructureToEmployees(input: $input) {
      data {
        assignmentResults {
          salaryStructureId
        }
      }
      code
      success
      message
    }
  }
`;

const assignSalaryStructureToEmployees = (
  queryVariables: AssignSalaryStructureToEmployeesGraphQLRequest,
) => {
  return graphQLApi<
    AssignSalaryStructureToEmployeesGraphResponse,
    AssignSalaryStructureToEmployeesGraphQLRequest
  >({
    query: assignSalaryStructureToEmployeesMutation,
    queryVariables,
  });
};

export default assignSalaryStructureToEmployees;
